import { render, staticRenderFns } from "./LargeBoxLinks.vue?vue&type=template&id=353c72c3&"
import script from "./LargeBoxLinks.vue?vue&type=script&lang=js&"
export * from "./LargeBoxLinks.vue?vue&type=script&lang=js&"
import style0 from "./LargeBoxLinks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports